<template lang="">
  <div>
    <router-link
      v-for="(item, index) in breadCrumbData"
      :key="index"
      :to="item.breadcrumbLink"
      class="active"
    >
      {{ item.breadcrumbLabel }} ></router-link
    >
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'BreadCrumbs',

  computed: {
    ...mapState('DATASET_STORE', ['breadCrumbData']),
  },
};
</script>

<style scoped></style>
